export interface AspenFeaturesState {
  assist: boolean;
  guardian: boolean;
  recordInstructionFiles: boolean;
  forwardCwes: boolean;
  adapt: boolean;
  recordRepoName: boolean;
  recordUsername: boolean;
  recordPrNumber: boolean;
}

export type AspenFeatureKey = keyof AspenFeaturesState;

export const ASPEN_FEATURE_META: Record<AspenFeatureKey, { group: string; field: string }> = {
  assist: { group: "aspen.assist", field: "hintsEnabled" },
  guardian: { group: "aspen.guardian", field: "enableAspenGuardian" },
  recordInstructionFiles: { group: "aspen.guardian", field: "recordInstructionFiles" },
  forwardCwes: { group: "aspen.guardian", field: "forwardCwes" },
  adapt: { group: "aspen.adapt", field: "enableAspenAdapt" },
  recordRepoName: { group: "aspen.adapt", field: "recordRepoName" },
  recordUsername: { group: "aspen.adapt", field: "recordUsername" },
  recordPrNumber: { group: "aspen.adapt", field: "recordPrNumber" },
};

export const ALL_ASPEN_FEATURES_DISABLED: AspenFeaturesState = {
  assist: false,
  guardian: false,
  recordInstructionFiles: false,
  forwardCwes: false,
  adapt: false,
  recordRepoName: false,
  recordUsername: false,
  recordPrNumber: false,
};
